import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import pencil from "../../../../Assets/Images/pencil.svg";
import ConfirmModal from "../../../../Components/ConfirmModal";
import { useDispatch } from "react-redux";
import { updateReportCard } from "../../../../redux/actions/report";
import "./style.css";

const EditModal = ({ show, handleClose, reportData, setReload }) => {

  const dispatch = useDispatch();

  const [formData, setFormData] = useState(reportData);
  const [activeCell, setActiveCell] = useState(null);

  const handleTextChange = e => setFormData({ ...formData, [e.target.name]: e.target.value })

  const handleInputChange = (e, index, isEdit) => {
    let { name, value } = e.target;
    if (name == "percentage") value = parseFloat(value);
    const reportcardDetails = formData?.reportcardDetails;
    const eleData = { ...reportcardDetails?.[index], [name]: value }
    if (isEdit != null) eleData["isEdit"] = isEdit;
    reportcardDetails[index] = eleData;
    setFormData({ ...formData, reportcardDetails: [...reportcardDetails] })
  }

  const handleEditScore = key => {
    setActiveCell(key);
  }

  const submitForm = () => {
    const data = { ...formData };
    const activityData = data?.reportcardDetails?.map(item => {
      if (item.isEdit) {
        return { categoryId: item.categoryId, percentage: item?.percentage, feedback: item?.feedback }
      } else {
        return { categoryId: item.categoryId, feedback: item?.feedback }
      }
    })
    const payload = {
      kidId: data?.kidId,
      reportcardDetails: activityData,
      overallFeedback: data?.overallFeedback
    }
    dispatch(updateReportCard(payload, () => {
      setReload(Math.random());
      handleClose();
    }));
  }

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton className="border-0">
        <Modal.Title>Edit</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-body px-4">
          <div className="modal-text">
            <p className="top-para">Student name : <b>{formData?.kidName}</b></p>
            <p className="top-para">Overall percentage marks : <b>{Math.ceil(formData?.overallPercentage)}%</b></p>
            {formData?.reportcardDetails?.map((item, index) => {
              return (<div key={index}>
                <div className="title mb-3">
                  <div className="input-group skills">
                    <span className="input-group-text ps-0 mb-0 fw-bold">{item?.categoryName} : {activeCell != index && `${Math.ceil(item?.percentage)}%`}</span>
                    {activeCell == index && <input type="number" name="percentage" onChange={(e) => handleInputChange(e, index, true)} value={item?.percentage} className={`form-control mb-0`} />}
                  </div>
                  {activeCell == index ? (
                    <div className="buttons">
                      <button className="btn save me-2" onClick={() => handleEditScore(null)} type="button">Save marks</button>
                      <button className="btn cancel" onClick={() => { handleEditScore(null); }}>Cancel</button>
                    </div>
                  ) : (
                    <div className="edit" onClick={() => handleEditScore(index)}>
                      <p className="edit mb-0 d-flex align-items-center">
                        <img src={pencil} alt="pencil" className="pencil me-1" />
                        <b>Edit marks</b>
                      </p>
                    </div>
                  )}
                </div>
                {item?.comments?.map((comment, key) => {
                  return (<div>
                    {/* <p className="bold-para mb-1">
                      <b>27 jan’23</b>
                      <span className="comment-span ms-3" onClick={() => handleEditFeedback({ categoryId: item?.categoryId, [`feedback${item?.categoryId}`]: comment })}>
                        <img src={pencil} alt="pencil" className="pencil me-1" />
                        <b>Edit comment</b>
                      </span>
                    </p> */}
                    <p className="desc">{comment}</p>
                  </div>)
                })}
                <div className="form"><label className="feedback-label mb-2 fw-semibold" htmlFor="floatingTextarea">Feedback</label>
                  <textarea className="form-control" name="feedback" onChange={e => handleInputChange(e, index, null)} value={item?.feedback} rows={"4"} />
                </div>
                <div className="border-line my-4"></div>
              </div>)
            })}
            <div className="form">
              <label className="feedback-label mb-2 mt-0 fw-semibold" htmlFor="floatingTextarea">Overall Feedback</label>
              <textarea className="form-control mb-4" name="overallFeedback" rows={"4"} onChange={handleTextChange} value={formData?.overallFeedback} />
            </div>
          </div>
        </div>
      </Modal.Body>
      <div className="row bottom-btn mb-4 justify-content-between mx-0 px-4">
        <div className="col-lg-6 col-md-6 col-6">
          <div className="d-grid gap-2">
            <button
              className="btn btns btn-left"
              type="button"
              data-bs-dismiss="modal"
              onClick={handleClose}
            >
              Cancel
            </button>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-6">
          <div className="d-grid gap-2">
            <ConfirmModal submitForm={submitForm} title="Save Changes" content="Are you sure you want to save and override the old marks?" cancel="Cancel" confirm="Save" button="Save" />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditModal;
